import React, { useRef } from 'react';
import { Text } from 'react-native-paper';
import { logNavegacao } from '../../../../function';
import { useSpring, animated } from 'react-spring';


function AnimatedComponent({visible, setShowColetas}) {
    const initialDelay = useRef(true);
    const bgStyle = useSpring({
        from: { backgroundColor: "#00c496", opacity: 1, width: 9, height: 9, borderRadius: 4},
        to: { backgroundColor: "#00c496", opacity: 0, width: 9, height: 9, borderRadius: 4 },
        delay: () => {
          if (initialDelay.current) {
            initialDelay.current = false;
            return 10000;
          }
          return 0;
        },
        config: { duration: 1000 },
        loop: true,
      });
      
    return (
        <div style={{width: "100%", marginTop: 10}}>
            {visible.ordem && (
                <div 
                    onClick={() => {
                        setShowColetas(true);
                        logNavegacao('Navegacao', 'Coleta');
                    }}
                    style={{marginBottom: 10, cursor: "pointer"}}>
                    <div style={{backgroundColor: "var(--main-secondy25)", borderRadius: 10}}>
                        <div style={{display: "flex", alignItems: "center", flexDirection: 'row', justifyContent: "space-between"}}>
                            <div style={{display: "flex", alignItems: "center", flexDirection: 'row', justifyContent: 'flex-start', paddingTop: 10, paddingBottom: 10}}>
                                <div style={{
                                    display: "flex",
                                    width: 18, 
                                    height: 18, 
                                    alignItems: "center", 
                                    justifyContent: "center", 
                                    borderColor: "#00000025", 
                                    borderWidth: 1, 
                                    borderRadius: 9,
                                    marginLeft: 15}}>
                                    <animated.div style={bgStyle}>
                                    </animated.div>
                                </div>
                                <Text style={{fontWeight: "500", marginLeft: 5}}>Veja aqui o status da(s) coleta(s) de hoje</Text>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
        
    );
}

export default AnimatedComponent;